import { render, staticRenderFns } from "./Home2.vue?vue&type=template&id=61a2c82e&scoped=true&"
import script from "./Home2.vue?vue&type=script&lang=js&"
export * from "./Home2.vue?vue&type=script&lang=js&"
import style0 from "./Home2.vue?vue&type=style&index=0&id=61a2c82e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a2c82e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a2c82e')) {
      api.createRecord('61a2c82e', component.options)
    } else {
      api.reload('61a2c82e', component.options)
    }
    module.hot.accept("./Home2.vue?vue&type=template&id=61a2c82e&scoped=true&", function () {
      api.rerender('61a2c82e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home2.vue"
export default component.exports